import {
	statisticsConstants
}from "./constants"

const initialState = {
	isSending      : false,
	homeStatistics : null
}

export default function (state = initialState, action){
	switch (action.type){
		case (statisticsConstants.GetHomeStatistics.REQUEST) :
			return {
				...state,
				isSending: true
			}
		case (statisticsConstants.GetHomeStatistics.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (statisticsConstants.GetHomeStatistics.SUCCESS):
			return {
				...state,
				isSending      : false,
				homeStatistics : action.payload.result
			}
		case (statisticsConstants.CLEAR):
			return {
				...initialState
			}
		default:
			return state
	}
}